import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type SuspensionRequalifiedProps = BaseNotificationItemProps & {
  type: 'suspension_requalified'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function SuspensionRequalified({ program, ...props }: SuspensionRequalifiedProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Requalified`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`You passed the requalification module for ${program.displayName}. You can work on this program again.`}</p>
      }
    />
  )
}
